module.exports = __webpack_public_path__ + "static/media/FolderGreenLight.c6e90824.svg";